import {toMillis} from "@/helpers/date";

export default {
    methods: {
        checkout_config_getFieldLabel(field) {

            if (field.label) {

                const translationKey = 'checkout_config.' + field.payload.field + '.' + field.label?.replace(/\.$/, '');

                if (this.$te(translationKey)) {

                    return this.$t(translationKey, {
                        user_approval_manager_email: this.$store.getters["user/approvalManagerEmail"] ?? ""
                    })
                }

                return field.label
            }

            return null;
        },
        checkout_config_getFields(config, {tags}) {

            tags = "undefined" === typeof tags ? [] : tags;

            const now = Date.now();

            return config
                .filter(field => undefined === field.tags || 0 < field.tags.filter(fieldTag => -1 !== tags.indexOf(fieldTag)).length)
                .filter(field => {

                    const startDate = toMillis(field.startDate);
                    const endDate = toMillis(field.endDate);

                    return (null === startDate || now >= startDate)
                        && (null === endDate || now <= endDate);
                })
                .map(field => {

                    if (field.validation) {

                        if (undefined === field.errors) {

                            field.errors = {}
                        }

                        Object.keys(field.validation).forEach(key => {

                            if (this.$te(`checkout_config.${field.payload.field}.errors.${key}`)) {

                                field.errors[key] = this.$t(`checkout_config.${field.payload.field}.errors.${key}`)
                            }
                        })
                    }

                    return field;
                });
        }
    }
}